import React from 'react';
import styled from 'styled-components/macro';

const StyledChangeArrow = styled('span')<any>`
  color: ${({ isPositive, theme }): string =>
    isPositive ? theme.PositiveChange : theme.NegativeChange};
  display: inline-block;
`;

interface IChangeArrowProps {
  changeValue: number;
  textValue: string;
}

const ChangeArrow: React.FC<IChangeArrowProps> = ({
  changeValue,
  textValue,
}) => {
  const isPositive = changeValue > 0;

  return (
    <StyledChangeArrow isPositive={isPositive}>
      <span aria-hidden>{isPositive ? '▲' : '▼'}</span> ({textValue})
    </StyledChangeArrow>
  );
};

export default ChangeArrow;
